import * as React from "react";

import { toast } from "@replo/design-system/components/toast/Toast";
import WorkspaceProvider from "@v2/contexts/WorkspaceProvider";
import DashboardLayout from "@v2/features/dashboard/DashboardLayout";
import { routes } from "@v2/utils/router";
import { Navigate, useParams } from "react-router-dom";
import { validate as isUUIDValid } from "uuid";

const WorkspaceDashboard: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { workspaceId } = useParams();

  if (!workspaceId || !isUUIDValid(workspaceId ?? "")) {
    toast.error({
      title: "Invalid workspace",
      description: "Please make sure you typed the URL correctly.",
    });
    return <Navigate to={routes.home.root} />;
  }

  return (
    <WorkspaceProvider
      workspaceId={workspaceId}
      saveWorkspaceIdAsLastVisited
      showToastOnNoAccess
      redirectOnNoAccess
    >
      <DashboardLayout contentIsCard={true} />
      {children}
    </WorkspaceProvider>
  );
};

export default WorkspaceDashboard;
